export const NCR = {};

//-------------------------------------------------------------------
NCR.UPDATE_PENDING_LIST = "UPDATE_PENDING_LIST";

//-------------------------------------------------------------------
NCR.UPDATE_TOTAL_LIST = "UPDATE_TOTAL_LIST";
//-------------------------------------------------------------------
